import axios from '../../utils/AxiosWrapper';
export const Type = {

    //ADD
    ADD_CLIENTGM_CALL: 'ADD_CLIENTGM_CALL',
    ADD_CLIENTGM_SUCCESS: 'ADD_CLIENTGM_SUCCESS',
    ADD_CLIENTGM_FAILED: 'ADD_CLIENTGM_FAILED',

    //GET
    GET_CLIENTGM_READ_CALL: 'GET_CLIENTGM_READ_CALL',
    GET_CLIENTGM_READ_SUCCESS: 'GET_CLIENTGM_READ_SUCCESS',
    GET_CLIENTGM_READ_FAILED: 'GET_CLIENTGM_READ_FAILED',

    //DELETE
    DELETE_CLIENTGM_CALL: 'DELETE_CLIENTGM_CALL',
    DELETE_CLIENTGM_SUCCESS: 'DELETE_CLIENTGM_SUCCESS',
    DELETE_CLIENTGM_FAILED: 'DELETE_CLIENTGM_FAILED',

    //REGION
    GET_REGION_TYPE_CALL: 'GET_REGION_TYPE_CALL',
    GET_REGION_TYPE_SUCCESS: 'GET_REGION_TYPE_SUCCESS',
    GET_REGION_TYPE_FAILED: 'GET_REGION_TYPE_FAILED',

    //CLIENTGROUP
    GET_CLIENTGROUP_TYPE_CALL: 'GET_CLIENTGROUP_TYPE_CALL',
    GET_CLIENTGROUP_TYPE_SUCCESS: 'GET_CLIENTGROUP_TYPE_SUCCESS',
    GET_CLIENTGROUP_TYPE_FAILED: 'GET_CLIENTGROUP_TYPE_FAILED',

    //MODULE
    GET_MODULE_TYPE_CALL: 'GET_MODULE_CALL',
    GET_MODULE_TYPE_SUCCESS: 'GET_MODULE_SUCCESS',
    GET_MODULE_TYPE_FAILED: 'GET_MODULE_FAILED',

    //SET
    SET_CLIENTGM_ROW_IN_REDUCER: 'SET_CLIENTGM_ROW_IN_REDUCER',
    SET_INITIAL_STATE: 'SET_INITIAL_STATE',
};

export function setInitialState(component) {
    return (dispatch) => {
        dispatch({
            type: Type.SET_INITIAL_STATE,
            data: component
        });
    }
}

export function getRegionType() {
    return (dispatch) => {
        dispatch({
            type: Type.GET_REGION_TYPE_CALL
        });

        axios.get('api/region/filter_region')
            .then(function (response) {
                dispatch({
                    type: Type.GET_REGION_TYPE_SUCCESS,
                    data: response.data
                });
            })
            .catch(function (error) {
                dispatch({
                    type: Type.GET_REGION_TYPE_FAILED
                });
            });
    }
}

export function getClientGroupType() {
    return (dispatch) => {
        dispatch({
            type: Type.GET_CLIENTGROUP_TYPE_CALL
        });

        axios.get('api/region/filter_klijent_grupa')
            .then(function (response) {
                dispatch({
                    type: Type.GET_CLIENTGROUP_TYPE_SUCCESS,
                    data: response.data
                });
            })
            .catch(function (error) {
                dispatch({
                    type: Type.GET_CLIENTGROUP_TYPE_FAILED
                });
            });
    }
}

export function getModuleType() {
    return (dispatch) => {
        dispatch({
            type: Type.GET_MODULE_TYPE_CALL
        });

        axios.get('api/klijent_grupa_modul/filter_modul')
            .then(function (response) {
                dispatch({
                    type: Type.GET_MODULE_TYPE_SUCCESS,
                    data: response.data
                });
            })
            .catch(function (error) {
                dispatch({
                    type: Type.GET_MODULE_TYPE_FAILED
                });
            });
    }
}


export function getClientGMs(state, instance) {
    return (dispatch) => {
        dispatch({
            type: Type.GET_CLIENTGM_READ_CALL
        });

        var config = {
            params: {
                page: state.page,
                pageSize: state.pageSize,
                sorted: state.sorted,
                filtered: state.filtered
            }
        };
        axios.get('api/klijent_grupa_modul/read', config)
            .then(function (response) {
                dispatch({
                    type: Type.GET_CLIENTGM_READ_SUCCESS,
                    data: response.data
                });
            })
            .catch(function (error) {
                dispatch({
                    type: Type.GET_CLIENTGM_READ_FAILED
                });
            });
    }
}

export function deleteClientGM(selection) {
    return (dispatch) => {
        dispatch({
            type: Type.DELETE_CLIENTGM_CALL,
        });

        axios.post(`api/klijent_grupa_modul/delete`, { selection: selection })
            .then(function (response) {
                dispatch({
                    type: Type.DELETE_CLIENTGM_SUCCESS,
                    data: response.data,
                    forDelete: selection
                });
            })
            .catch(function (error) {
                dispatch({
                    type: Type.DELETE_CLIENTGM_FAILED
                });
            });
    }
}

export function addClientGM(clientGMObj) {
    return (dispatch) => {
        dispatch({
            type: Type.ADD_CLIENTGM_CALL
        });

        axios.post('api/klijent_grupa_modul/create', clientGMObj)
            .then(function (response) {
                dispatch({
                    type: Type.ADD_CLIENTGM_SUCCESS,
                    data: response.data
                });
            })
            .catch(function (error) {
                dispatch({
                    type: Type.ADD_CLIENTGM_FAILED
                });
            });
    }
}


export function setRowInReducer(rowInfo) {
    return (dispatch) => {
        dispatch({
            type: Type.SET_CLIENTGM_ROW_IN_REDUCER,
            rowInfo: rowInfo
        })
    }
}